var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:exit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.625 15.188V11.1255H7.96094C7.79518 11.1255 7.63621 11.0596 7.519 10.9424C7.40179 10.8252 7.33594 10.6662 7.33594 10.5005C7.33594 10.3347 7.40179 10.1758 7.519 10.0585C7.63621 9.94134 7.79518 9.87549 7.96094 9.87549H13.625V5.81299C13.6244 5.23302 13.3937 4.67698 12.9836 4.26688C12.5735 3.85678 12.0175 3.62611 11.4375 3.62549H3.9375C3.35753 3.62611 2.80149 3.85678 2.39139 4.26688C1.98129 4.67698 1.75062 5.23302 1.75 5.81299V15.188C1.75062 15.768 1.98129 16.324 2.39139 16.7341C2.80149 17.1442 3.35753 17.3749 3.9375 17.3755H11.4375C12.0175 17.3749 12.5735 17.1442 12.9836 16.7341C13.3937 16.324 13.6244 15.768 13.625 15.188ZM17.116 11.1255L15.0582 13.1837C14.9459 13.3019 14.8843 13.4592 14.8864 13.6222C14.8885 13.7852 14.9541 13.9409 15.0694 14.0561C15.1846 14.1714 15.3403 14.237 15.5033 14.2391C15.6663 14.2412 15.8236 14.1795 15.9418 14.0673L19.0668 10.9423C19.1839 10.8251 19.2497 10.6662 19.2497 10.5005C19.2497 10.3348 19.1839 10.1759 19.0668 10.0587L15.9418 6.93369C15.8236 6.82143 15.6663 6.75977 15.5033 6.76185C15.3403 6.76394 15.1846 6.82961 15.0694 6.94486C14.9541 7.06011 14.8885 7.21583 14.8864 7.3788C14.8843 7.54178 14.9459 7.69912 15.0582 7.81729L17.116 9.87549H13.625V11.1255H17.116Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.53e788b3eae003a7152a0df974b3b0a3.svg";
export { ForwardRef as ReactComponent };